// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c0yY","childrenBlock":"styles_childrenBlock__2mDub"};